import React from 'react';
import { IntroFrontPage, PreviewBlockRenderer } from './PreviewBlockRenderer';
import { isIntroFrontPageEnabled, sanitizeLayoutMapping } from '../utils';

/**
 * Live configurator preview: intro front page, then the mapped layout.
 */
export default function ConfiguratorPreviewLayout({
    properties,
    pages,
    previewPageIndex,
    setPreviewPageIndex,
    previewSelections,
    setPreviewSelections,
    previewAvailableDomains,
    features,
    showIntroFrontPage,
    setShowIntroFrontPage
}) {
    const introEnabled = isIntroFrontPageEnabled(properties.designSettings);
    const layoutMapping = sanitizeLayoutMapping(properties.layoutMapping);
    const layoutTemplate = properties.layoutTemplate || 'split-70-30';

    const renderPreviewBlock = (blockName) => (
        <PreviewBlockRenderer
            key={blockName}
            blockName={blockName}
            pages={pages}
            previewPageIndex={previewPageIndex}
            setPreviewPageIndex={setPreviewPageIndex}
            previewSelections={previewSelections}
            setPreviewSelections={setPreviewSelections}
            previewAvailableDomains={previewAvailableDomains}
            features={features}
            designSettings={properties.designSettings}
            introEnabled={introEnabled}
            onReturnToIntro={() => setShowIntroFrontPage(true)}
        />
    );

    if (introEnabled && showIntroFrontPage) {
        return (
            <IntroFrontPage
                designSettings={properties.designSettings}
                onNext={() => {
                    setPreviewPageIndex(0);
                    setShowIntroFrontPage(false);
                }}
            />
        );
    }

    if (layoutTemplate === 'single-column') {
        return (
            <div style={{ maxWidth: '650px', width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                {layoutMapping.column1.map(block => renderPreviewBlock(block))}
                {layoutMapping.column2.map(block => renderPreviewBlock(block))}
            </div>
        );
    }

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: layoutTemplate === 'split-70-30' ? '7fr 3fr' :
                layoutTemplate === 'split-50-50' ? '1fr 1fr' : '3fr 7fr',
            gap: '2.5rem',
            width: '100%'
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                {layoutMapping.column1.map(block => renderPreviewBlock(block))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                {layoutMapping.column2.map(block => renderPreviewBlock(block))}
            </div>
        </div>
    );
}
